import React from 'react';
import PropTypes from 'prop-types';

import { RichText } from '$partials/global';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleText = ({ body, parentTypename, parent, isInAccordion }) => {

    return (
        <div className={`bg-white relative ${parent === 'Home' ? 'py-40 md:py-50' : parent === 'Detail' ? 'py-20 md:py-30' : 'py-40 md:py-60'}`}>
            <div className={`${isInAccordion ? 'sm:pr-20 md:pr-40' : 'layout-container'}`}>

                <RichText
                    className={`bg-white rich-text ${parentTypename === 'BvaModuleAccordion' ? 'w-full' : 'sm:w-4/6 md:w-7/12 sm:ml-w-1/6 md:ml-w-4/12 px-10 sm:px-20'}`}
                    {...body} />
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

ModuleText.propTypes = {
    body: PropTypes.object.isRequired,
    isInAccordion: PropTypes.bool,
    parentTypename: PropTypes.string,
    parent: PropTypes.string,
};

export default ModuleText;
